<template>
  <div class="session-request-modal">
    <div class="header">
      <label>
        REQUEST A SESSION WITH {{counselor.name | toUpperCase}}
      </label>
      <div class="exit" @click="close">
        <b>×</b>
      </div>
    </div>
    <session-request 
      :counselor="counselor" 
      @onrequest="handleOnRequest"
      @onerror="handleOnError" 
      @onreturn="handleOnReturn"
      @onsendamessage="handleOnSendAMessage" />
  </div>
</template>

<script>
import SessionRequest from './SessionRequest.vue'
export default {
  components: {
    SessionRequest,
  },
  props:{
    counselor:{
      type: Object, // { id: Number,  userId: Number }
      required: true
    }
  },
  methods:{
    close(){
      this.$modal.close()
    },
    handleOnRequest(payload) {
      this.close();
      this.$emit("onrequest", payload)
    },
    handleOnError(payload) {
      this.close();
      this.$emit("onerror", payload)
    },
    handleOnReturn(payload) {
      this.close();
      this.$emit("onreturn", payload)
    },
    handleOnSendAMessage(payload) {
      this.close();
      this.$emit("onsendamessage", payload);
    }
  }
}
</script>

<style lang="scss">
.v-modal__holder {
  @media (max-width: 800px) {
    padding: 0px;
  }
}
.v-modal__content {
  max-width: 875px;
  overflow-y:hidden;
  @media (max-width: 800px) {
    width: auto;
    overflow: auto;
  }
}
.session-request-modal {
  color: $light-gray;
  background-color: $dark-blue;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 15px 0px 10px;

    label {
      margin-top: 10px;
      letter-spacing: 0.1rem;
      font-size: 12px;
      color: $green;
    }
  }
  .exit {
    cursor: pointer;
    font-size: 25px;
  }
}
</style>